import { render, staticRenderFns } from "./PortfolioPage.vue?vue&type=template&id=68ec5bcd&scoped=true&"
import script from "./PortfolioPage.vue?vue&type=script&lang=js&"
export * from "./PortfolioPage.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioPage.vue?vue&type=style&index=0&id=68ec5bcd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ec5bcd",
  null
  
)

export default component.exports